export default "__VITE_ASSET__Csk0tmYB__"